// Imperative bridge so ExportHandler can ask SceneBackground to re-draw its
// background canvas at a specific size before rendering. Without this the
// background CanvasTexture is built for the editor viewport aspect and gets
// stretched when the export uses a different aspect.
//
// For a carousel slice the caller passes an optional `virtual` context: the
// background is laid out as if for a (virtual.fullWidth × virtual.fullHeight)
// canvas, but the texture only contains the sub-rect `[offsetX, offsetY,
// width, height]` of that layout — so `scene.background`, which Three.js
// stretches to fill the current GL viewport, ends up showing exactly the
// slice's portion of the wide layout instead of a squished wide background.

export interface RedrawVirtualContext {
  fullWidth: number
  fullHeight: number
  offsetX: number
  offsetY: number
}

type RedrawFn = (width: number, height: number, virtual?: RedrawVirtualContext) => void

let redraw: RedrawFn | null = null

const registerBgRedraw = (cb: RedrawFn | null) => {
  redraw = cb
}

const triggerBgRedraw = (width: number, height: number, virtual?: RedrawVirtualContext) => {
  redraw?.(width, height, virtual)
}

export {registerBgRedraw, triggerBgRedraw}
